export default __webpack_public_path__ + "images/b3c38e68af8d68396096bd20b04236dc.webp";